<template>
  <div class="three-less">
    <div class="three-less__buttons">
      <div
        v-for="(item, index) in buttons"
        :key="`button-${item.id}`"
        class="three-less__button"
      >
        <Button
          :text="item.text"
          :active="index === currentTab"
          @click="handleClickButton(index)"
        />
      </div>
    </div>
    <div class="three-less__items">
      <div
        class="three-less__item"
        v-for="(item, index) in contents"
        :key="`content-${item.id}`"
      >
        <keep-alive :max="3">
          <ThreeLessContent
            :is-viewport-active="isViewportActive"
            :content="item"
            :key="item.id"
            v-if="index === currentTab"
          />
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script>
import Button from './Button.vue'
import ThreeLessContent from './ThreeLessContent.vue'
export default {
  name: 'ThreeLess',
  components: {
    Button,
    ThreeLessContent,
  },
  props: {
    isViewportActive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      currentTab: 0,
      buttons: [
        {
          id: '1',
          text: 'Less Installation Effort',
        },
        {
          id: '2',
          text: 'Less TCO',
        },
        {
          id: '3',
          text: 'Less Fire Risk',
        },
      ],
      contents: [
        {
          id: '1',
          headline: `Easy Adjustment & Cable-Free Connection`,
          items: [
            {
              subcopy: `01. Preassembled LED Modules at Production Stage`,
              videoUrl: `/theme/rbFront/img/w/magnit/contents/Less_1-01_Less Installation Effort_Easy Adjustment-Cable-Frree Connection.mp4`,
              isEnded: false,
              coverImageUrl: `/theme/rbFront/img/w/magnit/contents/Less_1-01_Less Installation Effort_Easy Adjustment-Cable-Frree Connection.jpg`,
              bodycopy: `One of the biggest challenges when installing LED displays is front seam misalignment. LG MAGNIT overcomes this challenge with FLAT (Front Line Aligned Tiling), ensuring the front seams of the LED modules are precisely aligned during production. Additionally, pre-assembled LED modules allow for direct on-site installation, minimizing common installation issues.`,
              disclimer: ``,
            },
            {
              subcopy: `02. Cable-free Cabinet Connection`,
              videoUrl: `/theme/rbFront/img/w/magnit/contents/Less_1-02_Less Installation Effort_Easy Adjustment-Cable-Frree Connection.mp4`,
              isEnded: false,
              coverImageUrl: `/theme/rbFront/img/w/magnit/contents/Less_1-02_Less Installation Effort_Easy Adjustment-Cable-Frree Connection.jpg`,
              bodycopy: `With its cable-free signal transmission technology, LG MAGNIT eliminates the need for signal and power cable connections between cabinets, requiring cables only to connect the screen to its system controller and power.`,
              disclimer: ``,
            },
          ],
        },
        {
          id: '2',
          headline: `LED Monitoring`,
          items: [
            {
              subcopy: `Proactive Device Monitoring with LG ConnectedCare`,
              videoUrl: `/theme/rbFront/img/w/magnit/contents/Less_2_Power Efficiency.mp4`,
              isEnded: false,
              coverImageUrl: `/theme/rbFront/img/w/magnit/contents/Less_2_Power Efficiency.jpg`,
              bodycopy: `With LG ConnectedCare*, errors occurring in LG MAGNIT are automatically detected and reported to administrators via email, helping to minimize downtime. This proactive monitoring feature of LG ConnectedCare reduces management concerns, simplifies maintenance, and supports reliable display performance.`,
              disclimer: `*LG ConnectedCare is available for select LG MAGNIT models only and requires a separate subscription`,
            },
          ],
        },
        {
          id: '3',
          headline: `Fire Safety`,
          items: [
            {
              subcopy: `Flame-Resistant Design Through Insulated Materials`,
              videoUrl: `/theme/rbFront/img/w/magnit/contents/Less_3_Fire Safety.mp4`,
              isEnded: false,
              coverImageUrl: ``,
              bodycopy: `LG MAGNIT is constructed with flame-retardant materials designed to slow the spread of flames. Added resistance to impact and dust further enhances protection and durability in demanding environments.`,
              disclimer: `* Certifications may vary by model. Please consult your sales representative for details.`,
            },
          ],
        },
      ],
    }
  },
  methods: {
    handleClickButton(i) {
      this.currentTab = i
      this.$emit('click:tab', i)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/function.scss';
.three-less {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 65px;
  &__buttons {
    display: flex;
    gap: 50px;
    justify-content: center;
  }
  @media screen and (max-width: 1080px) {
    gap: calcQuarter(118);
    &__buttons {
      gap: calcQuarter(32);
    }
  }
}
</style>
